import {Box, Grid} from "@mui/material";
import React from "react";

import styles from "@/styles/theme/Dashboard.module.css";
import {useAppContext} from "@/contexts/AppContext.tsx";

export default function MainContainer({modal, children, background, fullWidth}: any) {
    const {theme, uiVisual, sidebar, sidebarWidth, modalWidth} = useAppContext();

    const padding = React.useMemo(() => modal ? modalWidth : 0, [modal, modalWidth]);
    const width = React.useMemo(() => fullWidth ? '100%' : sidebar ? `calc(100% - ${sidebarWidth + padding}px)` : `calc(100% - ${padding + 60}px)`, [fullWidth, sidebar, sidebarWidth, padding]);

    const sx = {
        classic: {
            background: '#F2F3F3',
        },
        modern: {
            background: theme === 'dark' ? 'white' : background
        }
    }

    return (
        <Grid item sx={{width}}>
            <Box className={styles.Wrapper} sx={sx[uiVisual]}>
                {children}
            </Box>
        </Grid>
    )
}